import React from 'react';
import { lighten, makeStyles, Theme } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import { Typography, CircularProgress } from '@material-ui/core';

import GridContainer from '../../@jumbo/components/GridContainer';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: lighten(theme.palette.background.paper, 0.1),
    },
    loadingMessage: {
        fontSize: 14,
        textAlign: 'center',
    },
}));

const Loading = ({ loadingMessage='' }) => {
    const classes = useStyles();

    return (
        <GridContainer>
            <Grid item xs={12}>
                <div className={classes.root}>
                    <Typography className={classes.loadingMessage}>
                        {loadingMessage || 'Loading...'}
                    </Typography>
                    <CircularProgress />
                </div>
            </Grid>
        </GridContainer>
    );
};

export default Loading;
